import { render, staticRenderFns } from "./confirmar-modal.vue?vue&type=template&id=820d1f9e&scoped=true"
import script from "./confirmar-modal.vue?vue&type=script&lang=js"
export * from "./confirmar-modal.vue?vue&type=script&lang=js"
import style0 from "./confirmar-modal.vue?vue&type=style&index=0&id=820d1f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820d1f9e",
  null
  
)

export default component.exports